import { render, staticRenderFns } from "./PackageStep.vue?vue&type=template&id=e674b046&scoped=true"
import script from "./PackageStep.vue?vue&type=script&lang=ts"
export * from "./PackageStep.vue?vue&type=script&lang=ts"
import style0 from "./PackageStep.vue?vue&type=style&index=0&id=e674b046&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e674b046",
  null
  
)

export default component.exports